import { render } from "./TransactionTypeDeduction.vue?vue&type=template&id=92261b6c&scoped=true"
import script from "./TransactionTypeDeduction.vue?vue&type=script&lang=js"
export * from "./TransactionTypeDeduction.vue?vue&type=script&lang=js"

import "./TransactionTypeDeduction.vue?vue&type=style&index=0&id=92261b6c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-92261b6c"

export default script